export interface IODataResult<T = any> {
  value: T[];
  '@odata.count': any;
}
